import Icon from './Icon';

const Share = ({ className }) => (
  <Icon name="share" className={className} viewBox="0 0 17 19">
    <path
      d="M13.5,12c-0.91,0-1.73,0.36-2.35,0.92l-4.27-2.56C6.95,10.08,7,9.8,7,9.5S6.95,8.92,6.88,8.64l4.27-2.56
    C11.77,6.64,12.59,7,13.5,7C15.43,7,17,5.43,17,3.5S15.43,0,13.5,0S10,1.57,10,3.5c0,0.3,0.05,0.58,0.12,0.86L5.85,6.92
    C5.23,6.36,4.41,6,3.5,6C1.57,6,0,7.57,0,9.5S1.57,13,3.5,13c0.91,0,1.73-0.36,2.35-0.92l4.27,2.56C10.05,14.92,10,15.2,10,15.5
    c0,1.93,1.57,3.5,3.5,3.5s3.5-1.57,3.5-3.5S15.43,12,13.5,12z"
    />
  </Icon>
);

export default Share;
